// Katalog pól formularza — kopia usppublicsite/src/content/insurance/motorForm.ts
// (tylko PL). Trzymać w zgodzie ze stroną publiczną.
export const CUSTOMER_TYPES = [
  { value: 'private', label: 'Osoba prywatna' },
  { value: 'company', label: 'Firma' }
];

export const CONTACT_FIELDS = [
  {
    key: 'fullName',
    label: 'Imię i nazwisko',
    required: true,
    autoComplete: 'name'
  },
  {
    key: 'phone',
    label: 'Telefon kontaktowy',
    required: true,
    kind: 'phone',
    autoComplete: 'tel',
    placeholder: '+48 ___ ___ ___'
  },
  {
    key: 'email',
    label: 'Adres e-mail',
    required: true,
    kind: 'email',
    autoComplete: 'email'
  }
];

export const COMPANY_FIELDS = [
  { key: 'companyName', label: 'Nazwa firmy', autoComplete: 'organization' },
  { key: 'nip', label: 'NIP', placeholder: '10 cyfr' }
];

export const VEHICLE_TYPES = [
  { value: 'car', label: 'Osobowy' },
  { value: 'van', label: 'Dostawczy do 3,5 t DMC' },
  { value: 'camper', label: 'Kamper lub przyczepa kempingowa' }
];

export const FINANCING_OPTIONS = [
  { value: 'owned', label: 'Własność' },
  { value: 'leasing', label: 'Leasing' },
  { value: 'credit', label: 'Kredyt' },
  { value: 'rental', label: 'Wynajem długoterminowy' }
];

export const VEHICLE_FIELDS = [
  {
    key: 'vehicleType',
    label: 'Typ pojazdu',
    required: true,
    kind: 'select',
    options: VEHICLE_TYPES
  },
  {
    key: 'financing',
    label: 'Finansowanie',
    required: true,
    kind: 'select',
    options: FINANCING_OPTIONS
  },
  { key: 'make', label: 'Marka', required: true, placeholder: 'np. Toyota' },
  { key: 'model', label: 'Model', required: true, placeholder: 'np. Corolla' },
  {
    key: 'year',
    label: 'Rok produkcji',
    required: true,
    kind: 'year',
    placeholder: 'RRRR'
  },
  { key: 'registration', label: 'Nr rejestracyjny' },
  { key: 'vin', label: 'VIN', wide: true }
];

export const COVER_OPTIONS = [
  { value: 'oc', label: 'OC' },
  { value: 'ac', label: 'AC' },
  { value: 'assistance', label: 'Assistance' },
  { value: 'nnw', label: 'NNW' }
];

export const COVER_FIELDS = [
  { key: 'currentInsurer', label: 'Obecny ubezpieczyciel' },
  { key: 'policyEnd', label: 'Koniec obecnej polisy', kind: 'date' }
];

export const T = {
  sec_contact: 'Dane kontaktowe',
  sec_vehicle: 'Pojazd',
  sec_cover: 'Zakres ochrony',
  sec_notes: 'Dodatkowe informacje',
  customerType: 'Klient',
  vehicleHint:
    'Pola bez gwiazdki są opcjonalne — numer rejestracyjny i VIN przyspieszają wycenę.',
  coverLabel: 'Jakie ubezpieczenie Cię interesuje?',
  coverHint: 'Zaznacz co najmniej jeden zakres.',
  notes: 'Dodatkowe informacje (opcjonalnie)',
  notesPlaceholder:
    'np. liczba i wiek kierowców, dotychczasowe zniżki, szkody w ostatnich latach, planowana data odbioru auta',
  selectPlaceholder: 'Wybierz…',
  requiredHint: 'pole wymagane',
  consent:
    'Wyrażam zgodę na przetwarzanie podanych danych w celu przygotowania oferty ubezpieczenia i na kontakt w tej sprawie.',
  submit: 'Wyślij zapytanie',
  submitting: 'Wysyłanie…',
  errRequired: 'To pole jest wymagane.',
  errEmail: 'Podaj poprawny adres e-mail.',
  errPhone: 'Podaj polski numer telefonu (9 cyfr, opcjonalnie z +48).',
  errYear: 'Podaj rok w formacie RRRR.',
  errChoice: 'Wybierz jedną z opcji.',
  errCover: 'Wybierz przynajmniej jeden zakres.',
  errSummary: 'Uzupełnij zaznaczone pola.',
  errGeneric: 'Coś poszło nie tak. Spróbuj jeszcze raz.',
  okTitle: 'Dziękujemy',
  okMsg:
    'Zapytanie trafiło do naszego biura. Porównamy pakiety sześciu towarzystw i odezwiemy się z ofertą lub pytaniami uzupełniającymi.'
};

export const optionLabel = (options, value) =>
  value
    ? (options.find((o) => o.value === value) || {}).label || value
    : undefined;

// Polskie numery: 9 cyfr (pierwsza niezerowa), opcjonalnie +48 / 0048 / 48.
const ALLOWED_CHARS_RE = /^\+?[\d\s()-]+$/;
const NATIONAL_RE = /^[1-9]\d{8}$/;

export function isPolishPhone(raw) {
  const v = raw.trim();
  if (!ALLOWED_CHARS_RE.test(v)) return false;
  const hasPlus = v.startsWith('+');
  let digits = v.replace(/\D/g, '');
  if (hasPlus) {
    if (!digits.startsWith('48')) return false;
    digits = digits.slice(2);
  } else if (digits.length === 13 && digits.startsWith('0048')) {
    digits = digits.slice(4);
  } else if (digits.length === 11 && digits.startsWith('48')) {
    digits = digits.slice(2);
  }
  return NATIONAL_RE.test(digits);
}
